import { elementType, node, object, string } from "prop-types"
import { LegacyHeading } from "../LegacyHeading"
import { Icon } from "../Icon"
import { Link as ReactRouterLink } from "react-router"

ActionBar.propTypes = {
  as: elementType,
  children: node.isRequired,
  className: string,
  style: object,
}
export function ActionBar({
  as: Comp = "div",
  className = "",
  children,
  style = {},
  ...rest
}) {
  return (
    <Comp
      className={`d-f ai-c jc-sb px-2 action-drawer action-bar ${className}`}
      style={{ gap: "1rem", ...style }}
      {...rest}
    >
      {children}
    </Comp>
  )
}

ActionBarPane.propTypes = {
  children: node.isRequired,
  className: string,
}
export function ActionBarPane({ className = "", children, ...rest }) {
  return (
    <ActionBar
      className={`p-s fd-c fd-r@xs ta-c ta-l@xs ${className}`}
      {...rest}
    >
      {children}
    </ActionBar>
  )
}
ActionBarPane.displayName = "ActionBar.Pane"
ActionBar.Pane = ActionBarPane

ActionBarLink.propTypes = {
  children: node.isRequired,
  className: string,
  to: string.isRequired,
}
export function ActionBarLink({ className = "", children, to = "", ...rest }) {
  return (
    <ActionBar
      as={ReactRouterLink}
      to={to}
      className={`fd-r ta-l mb-0 ${className}`}
      {...rest}
    >
      <ActionBar.Column>{children}</ActionBar.Column>
      <ActionBar.Action>
        <span className="c-tint3 fs-4">
          <Icon symbol="general#right-chevron" aria-hidden />
        </span>
      </ActionBar.Action>
    </ActionBar>
  )
}
ActionBarLink.displayName = "ActionBar.Link"
ActionBar.Link = ActionBarLink

ActionBarColumn.propTypes = {
  children: node.isRequired,
  className: string,
}
export function ActionBarColumn({ children, className = "" }) {
  return <div className={`d-f fd-c ai-fs fg-1 ${className}`}>{children}</div>
}
ActionBar.Column = ActionBarColumn

ActionBarRow.propTypes = {
  children: node.isRequired,
  className: string,
}
export function ActionBarRow({ children, className = "" }) {
  return <div className={`d-f fd-c fd-r@xs fg-1 ${className}`}>{children}</div>
}
ActionBar.Row = ActionBarRow

ActionBarTitle.propTypes = {
  children: node.isRequired,
}
export function ActionBarTitle({ children, ...restProps }) {
  return (
    <LegacyHeading
      level={2}
      size={4}
      color="tint1"
      text={children}
      {...restProps}
    />
  )
}
ActionBar.Title = ActionBarTitle

ActionBarDescription.propTypes = {
  children: node.isRequired,
}
export function ActionBarDescription({ children }) {
  return <p className="fs-4 m-0 c-tint1">{children}</p>
}
ActionBar.Description = ActionBarDescription

ActionBarAction.propTypes = {
  children: node.isRequired,
  className: string,
}
export function ActionBarAction({ children, className = "" }) {
  return <div className={className}>{children}</div>
}
ActionBar.Action = ActionBarAction
